import { DollarOutlined } from "@ant-design/icons";
import { VscReferences } from "react-icons/vsc";
import { HiExternalLink } from "react-icons/hi";
import { IoCubeOutline, IoReaderOutline } from "react-icons/io5";
import { RxAvatar } from "react-icons/rx";
import { MdOutlineSupportAgent, MdOutlineTune, MdPayment } from "react-icons/md";
import { RiCoupon3Line } from "react-icons/ri";
import { GoStack } from "react-icons/go";

/** Section headings for the desktop settings nav, in display order. */
export const getSettingsMenuGroups = (t) => [
    { key: "general", label: t("menuGroups.general", "General") },
    { key: "operations", label: t("menuGroups.operations", "Operations") },
    { key: "growth", label: t("menuGroups.growth", "Growth & Billing") },
];

export const getSettingsMenuItems = (t) => [
    {
        key: "1",
        group: "general",
        icon: <IoCubeOutline className="text-lg" />,
        label: t("companyInformation"),
        value: "companyInfo",
        tourId: "settings-company-info",
    },
    {
        key: "2",
        group: "general",
        icon: <MdOutlineSupportAgent className="text-lg" />,
        label: t("supportInformation.title"),
        value: "supportInfo",
    },
    {
        key: "3",
        group: "general",
        icon: <MdOutlineTune className="text-lg" />,
        label: t("preferences.preferences"),
        value: "userPreferences",
        tourId: "settings-preferences",
    },
    {
        key: "4",
        group: "general",
        icon: <DollarOutlined className="text-lg" />,
        label: t("taxInformation"),
        value: "taxInfo",
    },
    {
        key: "5",
        group: "operations",
        icon: <IoReaderOutline className="text-lg" />,
        label: t("rentalAgreement"),
        value: "rentalAgreement",
    },
    {
        key: "6",
        group: "operations",
        icon: <GoStack className="text-lg" />,
        label: t("integration"),
        value: "integration",
        tourId: "settings-integration",
    },
    {
        key: "7",
        group: "operations",
        icon: <RxAvatar className="text-lg" />,
        label: t("employee"),
        value: "employee",
    },
    {
        key: "8",
        group: "operations",
        icon: <HiExternalLink className="text-lg" />,
        label: t("bookingSite"),
        value: "bookingSite",
        tourId: "settings-booking-site",
    },
    {
        key: "9",
        group: "growth",
        icon: <VscReferences className="text-lg" />,
        label: t("referralCode"),
        value: "promoCode",
    },
    {
        key: "10",
        group: "growth",
        icon: <RiCoupon3Line className="text-lg" />,
        label: "Coupon Code",
        value: "couponCode",
    },
    {
        key: "11",
        group: "growth",
        icon: <MdPayment className="text-lg" />,
        label: "Billing",
        value: "billing",
    },
];
